import { RiskSeverity } from "components/risk/constants"

/** Shared utility helpers for risk/fraud management components */

/** Map a risk factor score (0-100) to a severity label */
export const scoreSeverity = (score: number): RiskSeverity => {
  if (score >= 80) return "TOO_HIGH"
  if (score >= 50) return "HIGH"
  if (score >= 25) return "MEDIUM"
  return "NO_RISK"
}

/** Build pie-chart data for risk level distribution */
export const buildRiskDistribution = (levels: { level_1: number; level_2: number; level_3: number; level_4: number }) => [
  { name: "Low", value: levels.level_1, color: "#22c55e" },
  { name: "Medium", value: levels.level_2, color: "#eab308" },
  { name: "High", value: levels.level_3, color: "#f97316" },
  { name: "Critical", value: levels.level_4, color: "#ef4444" }
]

/** Build pie-chart data for category average scores */
export const buildCategoryData = (breakdown: Record<string, { avg_score: number }>) => [
  { name: "Financial", value: Math.round(breakdown.financial.avg_score), color: "#3b82f6" },
  { name: "Profile", value: Math.round(breakdown.profile.avg_score), color: "#8b5cf6" },
  { name: "Behavioral", value: Math.round(breakdown.behavioral.avg_score), color: "#f59e0b" }
]
